import Cookies from 'js-cookie';
import addCookieWithConsent from '../../utilities/addCookieWithConsent';
import forceLogoutHandler from './a.users.forceLogoutHandler';

import {
  loadToken,
  tryToGetUserLog
} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// EditUserPassword
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestEditUserPassword = packet => {
  return {
    type: 'REQUEST_EDIT_USER_PASSWORD',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveEditUserPasswordSuccess = data => ({
  type: 'RECEIVE_EDIT_USER_PASSWORD_SUCCESS',
  data
})

export const receiveEditUserPasswordFail = data => ({
  type: 'RECEIVE_EDIT_USER_PASSWORD_FAIL',
  data
})

export const tryToEditUserPassword = packet => (dispatch, getState) => {

  dispatch(requestEditUserPassword(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/users/password', {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveEditUserPasswordSuccess(json));
      dispatch(tryToGetUserLog({type: 'password'}))
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveEditUserPasswordFail({errors:e, lastSubmit: packet}));
    })
}
